import React from "react";
import clsx from "clsx";
import { TextField, Autocomplete } from "@mui/material";

// The lookupvalues could be an array with only strings or
// an array of objects with label and value keys. We want
// to support both options
function isSeparateLabelValue(values) {
  return values?.length > 0 && typeof values[0] === "object";
}

function getNameFromValue(options, value) {
  if (!isSeparateLabelValue(options)) {
    return String(value);
  }

  const option = options.filter((tuple) => tuple.value === value)[0];
  if (option) {
    return option.label;
  }
  return "";
}

function getValues(options) {
  if (isSeparateLabelValue(options)) {
    return options.map((option) => option.value);
  } else {
    return options;
  }
}

export default function LookupField({
  className,
  data,
  formStateHandlers,
  fieldSetting,
  helperText,
  variant,
  required,
  inputProps,
  ...props
}) {
  const { raw } = formStateHandlers;
  const fieldConfig = raw({
    ...fieldSetting,
    onChange: (input) => {
      const value = input.selectValue ?? "";
      fieldSetting.onChange({
        target: {
          value,
        },
      });
      return value;
    },
    validate: (value) => {
      return !required || !!value;
    },
  });

  const fieldProps = {
    ...fieldConfig,
    ...props,
    id: `lookup_${fieldConfig.name}`,
    className: clsx(className),
  };

  const finalInputProps = {
    label: props.label,
    error: props.error,
    variant,
    required,
    helperText,
    ...inputProps,
  };
  return (
    <Autocomplete
      {...fieldProps}
      onChange={(e, value) => {
        // Re-package value, useFormState does not pass through second arg
        e.selectValue = value;
        return fieldConfig.onChange(e);
      }}
      options={getValues(data.values)}
      getOptionLabel={(value) => getNameFromValue(data.values, value)}
      renderInput={(params) => (
        <TextField
          {...params}
          {...finalInputProps}
          fullWidth
          label={
            finalInputProps.required
              ? `${finalInputProps.label} (required)`
              : finalInputProps.label
          }
          error={data?.isFieldFailed}
          InputLabelProps={{
            // hard coded to true to position label above input
            shrink: true,
            // hard coded to false to prevent an asterisk from showing
            required: false,
          }}
        />
      )}
    />
  );
}
